export default [
  {
    name: 'firstName',
    label: 'First Name *',
    validation: 'required',
    validationMessages: {
      required: 'First name is required.'
    }
  },
  {
    name: 'lastName',
    label: 'Last Name *',
    validation: 'required',
    validationMessages: {
      required: 'Last name is required.'
    }
  },
  {
    name: 'email',
    label: 'Your email',
    validation: 'required|email',
    validationMessages: {
      required: 'Your email is required.'
    }
  },
  {
    name: 'message',
    label: 'Your message',
    validation: 'required',
    type: 'textarea',
    validationMessages: {
      required: 'Your message is required.'
    }
  }
]